/**
 * pc-piller-scroll-spy.js
 * Handles:
 * 1. Anchor nav highlight on scroll (IntersectionObserver)
 * 2. Buying guide topic click + scroll highlight
 */
(function () {
  'use strict';

  /* ===== Anchor Nav Scroll Spy ===== */
  var nav = document.querySelector('[data-component="piller-anchor-nav"]');
  if (nav) {
    var anchors = Array.prototype.slice.call(nav.querySelectorAll('[data-bind="anchor-item"]'));
    var sectionIds = anchors.map(function (a) {
      return a.getAttribute('href').replace('#', '');
    }).filter(Boolean);

    var sections = sectionIds.map(function (id) {
      return document.getElementById(id);
    }).filter(Boolean);

    if (sections.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var id = entry.target.id;
            anchors.forEach(function (a) {
              if (a.getAttribute('href') === '#' + id) {
                a.setAttribute('data-active', '');
              } else {
                a.removeAttribute('data-active');
              }
            });
          }
        });
      }, {
        rootMargin: '-80px 0px -60% 0px',
        threshold: 0
      });

      sections.forEach(function (s) { observer.observe(s); });
    }
  }

  /* ===== Buying Guide Topic Highlight ===== */
  var guide = document.querySelector('[data-component="piller-buying-guide"]');
  if (guide) {
    var topicLinks = Array.prototype.slice.call(guide.querySelectorAll('[data-bind="topics"] a'));
    var panels = guide.querySelector('[data-bind="panels"]');

    if (topicLinks.length && panels) {
      var panelSections = Array.prototype.slice.call(panels.querySelectorAll('[id]'));

      topicLinks.forEach(function (link) {
        link.addEventListener('click', function (e) {
          topicLinks.forEach(function (l) { l.removeAttribute('data-active'); });
          link.setAttribute('data-active', '');
        });
      });

      if (panelSections.length) {
        var guideObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var id = entry.target.id;
              topicLinks.forEach(function (l) {
                if (l.getAttribute('href') === '#' + id) {
                  l.setAttribute('data-active', '');
                } else {
                  l.removeAttribute('data-active');
                }
              });
            }
          });
        }, {
          rootMargin: '-100px 0px -50% 0px',
          threshold: 0
        });

        panelSections.forEach(function (s) { guideObserver.observe(s); });
      }
    }
  }
})();
